import moment from 'moment'

export const REPORT_DATE_FORMAT = 'YYYY-MM-DD'
export const REPORT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export const getReportParameterType = (item = {}) => {
  const configuredType = String(item?.paramType || '').trim().toLowerCase()
  if (configuredType) return configuredType

  const fieldName = String(item?.field || item?.title || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')

  if (fieldName.includes('datetime')) return 'datetime'
  if (fieldName.includes('date')) return 'date'

  return ''
}

export const normalizeReportParameterValue = (item = {}) => {
  const value = item?.value
  if (value === '' || value === null || typeof value === 'undefined') {
    return value
  }

  const paramType = getReportParameterType(item)

  if (!['date', 'datetime'].includes(paramType)) {
    return value
  }

  const parsedValue =
    typeof value === 'string'
      ? moment(
          value,
          [moment.ISO_8601, REPORT_DATETIME_FORMAT, REPORT_DATE_FORMAT],
          true,
        )
      : moment(value)
  if (!parsedValue.isValid()) return value

  return parsedValue.format(
    paramType === 'datetime' ? REPORT_DATETIME_FORMAT : REPORT_DATE_FORMAT,
  )
}
